









import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";
import { IContentSource } from "../../domain/drawing";
import { HelpFileInformation } from "../../domain/help";
import { HelpFileSelectDialog } from "./dialogs";

@Component({
  components: {
    HelpFileSelectDialog,
  },
})
export default class HelpView extends Mixins() {
  data() {
    return {
      helpFiles: [] as HelpFileInformation[],
    };
  }
  helpFiles: HelpFileInformation[];

  $refs!: {
    helpFileSelectDialog: HelpFileSelectDialog,
  };

  get isHelpEnable(): boolean {
    return this.$configuration.system.help.isEnable;
  }

  get hasHelpFiles(): boolean {
    return this.helpFiles.length > 0;
  }

  mounted() {
    if (this.isHelpEnable) {
      this.getFiles();
    }
  }

  private getFiles() {
    const repository = DomainRegistry.instance.help.getHelpRepository();
    repository.getFiles(location.pathname,
      this.$store.getters.hostName,
      this.$store.getters.user.profession ? this.$store.getters.user.profession.id : null)
    .then(value => {
      this.helpFiles = value.sort((a, b) => this.sortHelpFiles(a, b));
    })
    .catch(e => {
      this.$error(
        "ヘルプファイル取得失敗",
        "ファイルの取得に失敗しました。",
        e,
      );
    });
  }

  sortHelpFiles(source: HelpFileInformation, destination: HelpFileInformation): number {
    const sourceIndex = (source.windowName === location.pathname) ? 0 : 1;
    const destinationIndex = (destination.windowName === location.pathname) ? 0 : 1;
    if (sourceIndex !== destinationIndex) {
      return sourceIndex - destinationIndex;
    } else if (source.terminalName !== destination.terminalName) {
      return (source.terminalName > destination.terminalName) ? -1 : 1;
    } else if (source.professionCode !== destination.professionCode) {
      return (source.professionCode > destination.professionCode) ? -1 : 1;
    } else if (source.name !== destination.name) {
      return source.name < destination.name ? -1 : 1;
    } else {
      return source.id - destination.id;
    }
  }

  showHelpFiles() {
    if (this.helpFiles.length === 1) {
      const file = this.helpFiles[0];
      this.openHelpFileViewer(file);
    } else if (this.helpFiles.length > 1) {
      this.$refs.helpFileSelectDialog.show(this.helpFiles, f => this.openHelpFileViewer(f));
    }
  }

  private openHelpFileViewer(file: HelpFileInformation): void {
    if (file.name.indexOf(".pdf") !== -1) {
      this.openWindow(file);
    } else {
      this.openFile(file);
    }
  }

  private openWindow(file: HelpFileInformation) {
    this.getHelpFileSource(file.id)
    .then(source => {
      if (!source) { 
        this.$error("ヘルプファイルエラー", "ヘルプファイルを取得できませんでした。");
        return;
      }
      const param = {
        name: file.name,
        encodedUri: encodeURIComponent(source.source),
        isPrintable: true.toString(),
      };
      this.$openWindow("/ShowDocumentSimply", param);
    });
  }

  private openFile(file: HelpFileInformation): void {
    this.getHelpFileSource(file.id)
    .then(source => {
      if (!source) { return; }
      this.$openWindow(source.source);
    });
  }

  private async getHelpFileSource(fileId: number): Promise<IContentSource> {
    const repository = DomainRegistry.instance.help.getHelpRepository();
    return repository.getFile(fileId);
  }
}
